(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pv-card-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('.pv-cs__i');
    if (!a) return;
    var card = a.closest('product-card, .product-card, li, .card');
    var img = card && card.querySelector('img:not(.pv-cs img)');
    if (!img) return;
    img.removeAttribute('srcset');
    img.src = a.dataset.src;
    a.parentNode.querySelectorAll('.pv-cs__i').forEach(function (x) { x.classList.toggle('is-on', x === a); });
  });
  } catch(e) { console.error(e); }
})();

})();
